import IDSBT from '@/assets/website/id_vitae.png';
import XPSBT from '@/assets/website/xp_vitae.png';
export default function HowToUse() {
  return (
    <div>
      <p className="mx-4 mb-14 mt-40 text-center text-3xl font-bold text-[#4e4e4e]">
        How to Use Vitae?
      </p>
      <div className="mx-10 flex flex-wrap justify-center">
        <HowUseCard
          src={IDSBT}
          forName="Identity Vitae"
          desc="Use it to issue identities and manage your organizational structure"
        />
        <HowUseCard
          src={XPSBT}
          forName="Experience Vitae"
          desc="Use it to record events, motivate members, and collect event history"
        />
      </div>
    </div>
  );
}

interface Props {
  src: string;
  forName: string;
  desc: string;
}

function HowUseCard(props: Props) {
  return (
    <div className="relative mx-8 min-h-[600px] max-w-[556px] items-center justify-center rounded-[62px] font-sans">
      <div className="flex-none">
        <img
          src={props.src}
          className="inset-0 h-full w-full object-cover"
          loading="lazy"
        />
      </div>
      <p className="mt-[47px] mb-[25px] text-center text-2xl font-bold text-[#4e4e4e]">
        {props.forName}
      </p>
      <p className="mx-4 text-center text-lg text-[#4e4e4e]">{props.desc}</p>
    </div>
  );
}
